import * as React from 'react';
import { StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { Colors, Fonts } from '../utils/Constants';

export default class AddressForm extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
        clicked: false,
        address: '',
        editing: false
    }
  }

  clickedButton = () => {
    this.props.getRepresentatives(this.state.address);
    this.setState({editing: false});
  }

  render(){
    let dynamic_styling = {};
    if (this.props.screenWidth < 520) {
      dynamic_styling.textinput = {
        width: '100%',
        marginBottom: 20
      }
      dynamic_styling.button = {
        width: '100%'
      }
    } else {
      dynamic_styling.textinput = {
        flex: 1
      }
      dynamic_styling.button = {
        flex: 1
      }
    }
    var showFinished = false; //show finished state
    var showAddress = false; //show address input rather than zipcode
    if (!!this.props.representatives && !!this.props.location) {
      if(this.props.representatives.representatives.length === 0){
        showAddress = true;
        dynamic_styling.textinput.borderWidth = 2;
        dynamic_styling.textinput.borderColor = 'red';
      } else if (!this.state.editing){
        showFinished = true;
      }
    }
    return (
      <View style={[styles.parent, {width: this.props.width, backgroundColor: showFinished ? '#F6F6F6':'#3B5EDA'}]}>
        {!showFinished &&
          <View>
          <Text style={{fontFamily: Fonts.mainFont, fontSize: 17, fontWeight: 'bold', color: 'white', marginBottom: 10}}>
            {"Enter your " + (showAddress ? "full address" : "zip code")}
          </Text>
          <Text style={{fontFamily: Fonts.mainFont, fontSize: 13, fontWeight: 'normal', color: 'white', marginBottom: 20}}>
            {showAddress ? "Multiple districts overlap in your zipcode, DYP needs your full address to find all of your representatives":"DYP will look up your government representatives"}
          </Text>
        </View>
        }
        {!showFinished &&
        <View style={{flexDirection: this.props.screenWidth < 520 ? 'column':'row', alignSelf: 'center', width: '100%'}}>
          <TextInput
            style={[styles.textinput, dynamic_styling.textinput]}
            onChangeText={(text) => this.setState({address: text})}
            value={this.state.address}
            placeholder={showAddress ? "Full Address" : "Zip Code"}
          />
          <TouchableOpacity style={dynamic_styling.button} onPress={this.clickedButton}>
            <View style={[styles.button, dynamic_styling.button, {backgroundColor: 'white'}]}>
              <Text style={{color: 'black', fontFamily: Fonts.mainFont, fontSize: 17}}>
                Find Representatives
              </Text>
            </View>
          </TouchableOpacity>
        </View>
        }
        {showFinished &&
          <View style={{flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'space-between'}}>
            <Text style={{fontFamily: Fonts.mainFont, fontSize: 17, fontWeight: 'normal'}}>
              <Text style={{fontWeight:'bold'}}>{"Your location is: \n"}</Text>
              {this.props.location}
            </Text>
            <TouchableOpacity style={{marginLeft: 10}} onPress={() => this.setState({editing: true})}>
              <View style={[styles.button, {padding: 10, backgroundColor: 'black',}]}>
                <Text style={{color: 'white', fontFamily: Fonts.mainFont, fontSize: 17}}>
                  Edit
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        }
      </View>
    );
  }
}

const styles = StyleSheet.create({
  button: {
    // borderRadius: 11,
    height: 50,
    alignItems: 'center',
    justifyContent: 'center'
  },
  parent: {
    padding: 25,
    marginBottom: 20,
  },
  textinput: {
    fontSize: 17,
    height: 50,
    padding: 15,
    backgroundColor: 'white',
    // borderRadius: 10,
    marginRight: 20
  }
});